import './LoadingContainer.css';

import { IonPage, IonSpinner, IonText } from '@ionic/react';
import React from 'react';
import { ImpulseSpinner } from 'react-spinners-kit';

interface Props {
    startup?: boolean
    loading: boolean,
}

const LoadingContainer: React.FC<Props> = (props) => {
    let spinner = null;
    if (props.startup) {
        spinner = <IonPage className="loading-startup">
            <img src="/assets/images/logo_text.png" />
            <IonText>کمک های مردمی برای حفظ محیط زیست</IonText>

            <ImpulseSpinner frontColor="#ffffff" backColor="#ffffffAA" size={30} />
        </IonPage>
    } else {
        spinner = <IonPage className="loading-container">
            <ImpulseSpinner frontColor="#08b98a" backColor="#08b98a30" size={30} />
        </IonPage>
    }

    return <>
        {props.children}
        {props.loading ? spinner : null}
    </>
}

export default LoadingContainer